export type FieldEditType = 'text' | 'country' | 'industry' | 'provider' | 'productStatus' | 'mappingStatus'

export interface FieldConfig {
  key: string
  label: string
  required?: boolean
  editType?: FieldEditType
  truncate?: boolean
  // A field the import may read to match an existing entity but must never write, such as
  // the platform's own entity id. Shown for context; never editable, never a merge choice.
  readOnly?: boolean
}

export function getFieldConfig(configs: FieldConfig[], key: string): FieldConfig | undefined {
  return configs.find(f => f.key === key)
}

export function getFieldLabel(configs: FieldConfig[], key: string): string {
  return getFieldConfig(configs, key)?.label ?? key
}

export function isReadOnlyField(configs: FieldConfig[], key: string): boolean {
  return getFieldConfig(configs, key)?.readOnly === true
}
